import { StyledCell } from '../../Table.style';
import _ from 'lodash';
const AdditionalValueCell = ({ pr, value_key }) => {
  return (
    <StyledCell data-testid='additional-value-cell'>
      {_.get(pr, value_key, 'N/A')}
    </StyledCell>
  );
};

export default AdditionalValueCell;
